import { render, staticRenderFns } from "./studioEditor.vue?vue&type=template&id=c58eae98&scoped=true"
import script from "./studioEditor.vue?vue&type=script&lang=js"
export * from "./studioEditor.vue?vue&type=script&lang=js"
import style0 from "./studioEditor.vue?vue&type=style&index=0&id=c58eae98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58eae98",
  null
  
)

export default component.exports